// @flow
import * as R from 'ramda'

export const getActiveTrack = (field: string = 'active') => R.find(R.propEq(field, true))
